/* eslint-disable */

export const storefront = {
    namespaced: true,
    state: {
        category_list: [],
        category_list_raw: {},
        store_list: [],
        store_category_list: [],
        isLoading: false,
        currentShop: {},
    },
    mutations: {
        SET_LOADING (state, payload) {
          state.isLoading = payload
        },
        SET_CATEGORY_LIST (state, payload) {
            state.category_list = payload
        },
        SET_STORE_LIST (state, payload) {
            state.store_list = payload
        },
        SET_STORE_CATEGORY_LIST (state, payload) {
            state.store_category_list = payload
            // console.log('entra aqui ', payload)
            state.isLoading = false
        },
        SET_CATEGORY_LIST_RAW(state, payload){
          state.category_list_raw = payload
          state.isLoading = false
        },
        SET_CURRENT_SHOP(state, payload){
            // console.log(payload)
            state.currentShop = payload
        }
    },

    actions: {
        loadCategories ({ commit, state, rootState }) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true)
                const path = 'main-categories/en'
                const loadCommit = 'SET_CATEGORY_LIST'
                firebase.database().ref(path).orderByChild('name').once('value',
                    function (snapshot) {
                        const items = Object.values(snapshot.val())
                        const rawCategories = Object.entries(snapshot.val())
                        items.sort(function(a, b){
                            if(a < b) { return -1; }
                            if(a > b) { return 1; }
                            return 0;
                        })
                        commit(loadCommit, items)
                        commit('SET_CATEGORY_LIST_RAW', rawCategories)
                        resolve()
                    }, function (error) {
                        // console.log(error)
                        commit('SET_LOADING', false)
                        reject()
                    },
                )
            })
        },
        loadStores ({ commit, state, rootState }) {
            return new Promise((resolve, reject) => {
                const path = 'virtualshop'
                const loadCommit = 'SET_STORE_LIST'
                firebase.database().ref(path).orderByChild('name').once('value',
                    function (snapshot) {
                        const items = Object.values(snapshot.val())
                        commit(loadCommit, items)
                        resolve()
                    }, function (error) {
                        // console.log(error)
                        reject()
                    },
                )
            })
        },
        setCategorieStore ({ commit, state, rootState }, payload) {
            return new Promise((resolve, reject) => {
                commit('SET_LOADING', true)
                const loadCommit = 'SET_STORE_CATEGORY_LIST'
                if (payload !== 'Todas') {
                  const category = state.category_list_raw.filter(item => item[1]=== payload )
                  const found = state.store_list.filter(store => store.dataShop.mainCategorie.id === category[0][0] )
                  commit(loadCommit, found)
                } else {
                  commit(loadCommit, state.store_list)
                }
                commit('SET_LOADING', false)
                resolve()
            })
        },
        setCurrentShop ({ commit, state}, payload) {
            // console.log(payload)
            commit('SET_CURRENT_SHOP', payload)
        }
    },
    getters: {
        isLoading (state) {
          return state.isLoading
        },
        getCategories (state) {
            return state.category_list
        },
        getStoreCategorie (state) {
            return state.store_category_list
        },
        getCurrentShop (state) {
            return state.currentShop
        },
    },

}
